import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';
import { infoSelector } from 'selectors/indicator';
import getViewProperties from 'services/getViewProperties';

// Components
import { Helmet } from 'react-helmet';
import Breadcrumb from 'components/breadcrumb';

// Styles
import styles from './indicatorHeader.scss';

const IndicatorHeader = ({
  match: { params: { category, indicatorName, renderType } },
  info: {
    title, description, shortTitle,
  },
  showNarrative,
  children,
}) => {
  // Do not render the header if we are embedding or exporting.
  const { isMinimalView } = getViewProperties(renderType);
  if (isMinimalView) {
    return null;
  }

  const label = 'usdata' === category ?
    'U.S. Indicators' :
    'International Indicators';

  const breadcrumbs = [
    {
      destination: `/${category}`,
      label,
    },
    {
      destination: `/${category}/indicator/${indicatorName}/snapshot`,
      label: shortTitle,
    },
  ];

  return (
    <div className={styles.indicatorHeader}>
      <Helmet>
        <title>
          {label}: {title} - PRB
        </title>
      </Helmet>
      <Breadcrumb items={breadcrumbs} />
      <h1
        className={styles.title}
      >
        <Switch>
          <Route
            path="/:category/indicator/:indicatorName/table/:state/counties"
            render={({ match }) => (
              <span>{shortTitle} of {match.params.state}</span>
            )}
            exact
          />
          <Route
            render={() => (<span>{title}</span>)}
          />
        </Switch>
      </h1>
      {showNarrative && description &&
        <ReactMarkdown className={styles.description} source={description} />
      }
      {children}
    </div>
  );
};

IndicatorHeader.defaultProps = {
  info: {
    title: '',
    description: '',
    shortTitle: '',
  },
  showNarrative: false,
  children: null,
};

IndicatorHeader.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
      indicatorName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  info: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    shortTitle: PropTypes.string,
  }),
  showNarrative: PropTypes.bool,
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({
  info: infoSelector(state),
});

export default withRouter(connect(mapStateToProps)(IndicatorHeader));




// WEBPACK FOOTER //
// ./app/components/indicatorHeader/index.js